export const GetNextMonday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 1) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextTuesday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 2) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextWednesday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 3) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextThursday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 4) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextFriday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextSaturday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 6) % 7 || 7),
        ),
    );

    return nextFriday;
}

export const GetNextSunday = () => {
    const date = new Date();
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
        dateCopy.setDate(
            dateCopy.getDate() + ((7 - dateCopy.getDay() + 7) % 7 || 7),
        ),
    );

    return nextFriday;
}